import { cn } from 'components/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from 'components/ui/tooltip';

import { useFormHistory } from './useFormHistory';

const UNDO_ICON = '/assets/icons/undo.png';
const REDO_ICON = '/assets/icons/redo.png';

export const FormControllers: React.FC = () => {
  const { canUndo, canRedo, undo, redo } = useFormHistory();

  return (
    <div className="flex gap-0.5 select-none">
      <Tooltip>
        <TooltipTrigger asChild>
          <img
            src={UNDO_ICON}
            alt="undo"
            className={cn(
              'w-4 h-4 m-2 cursor-pointer',
              canUndo ? 'opacity-100' : 'opacity-50 cursor-default'
            )}
            onClick={canUndo ? undo : undefined}
          />
        </TooltipTrigger>
        <TooltipContent>
          <p className="bg-[#71717A] text-white text-xs px-2 py-1 rounded-md">
            Undo
          </p>
        </TooltipContent>
      </Tooltip>

      <Tooltip>
        <TooltipTrigger asChild>
          <img
            src={REDO_ICON}
            alt="redo"
            className={cn(
              'w-4 h-4 m-2 cursor-pointer',
              canRedo ? 'opacity-100' : 'opacity-50 cursor-default'
            )}
            onClick={canRedo ? redo : undefined}
          />
        </TooltipTrigger>
        <TooltipContent>
          <p className="bg-[#71717A] text-white text-xs px-2 py-1 rounded-md">
            Redo
          </p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
};
